<template>
    <div
                class="product-colour"
                :class="{
                  'colour-red': result._source.Colour[0] === 'Red',
                  'colour-white': result._source.Colour[0] === 'White',
                  'colour-rose': result._source.Colour[0] === 'Rose',
                  'colour-spirit': result._source.Colour[0] === 'Spirit',
                  'colour-beer': result._source.Colour[0] === 'Beer',
                  'colour-cider': result._source.Colour[0] === 'Cider',
                }"
              >
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="
                    result._source.Colour[0] === 'Red' ||
                    result._source.Colour[0] === 'White' ||
                    result._source.Colour[0] === 'Rose'
                  "
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/wine-glass-alt.svg#wine"
                  />
                </svg>
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="result._source.Colour[0] === 'Beer'"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/beer.svg#beer"
                  />
                </svg>
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="result._source.Colour[0] === 'Spirit'"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/wine-bottle.svg#wine-bottle"
                  />
                </svg>
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="result._source.Colour[0] === 'Cider'"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/apple-alt.svg#apple"
                  />
                </svg>

                <span v-if="result._source.Colour[0] === 'Beer'">
                  {{ result._source.Type }}</span
                >
                <span v-else-if="result._source.Colour[0] === 'Spirit'">
                  {{ result._source.Type }}</span
                >
                <span v-else>
                  {{ result._source.Colour[0] }}
                </span>
              </div>
</template>

<script>
    export default {
      props: {
        result: {
          type: [Boolean, Object],
          default: false
        }
      }
    }
</script>
